import fetcher from './fetcher';
export default function saveLeadBillingDetails({ leadId, data }) {
    return fetcher({
        url: `/api/v1/billing/leads/${leadId}`,
        method: 'POST',
        data
    });
}
